import { atom } from "recoil";

export const loadingProgressState = atom({
    key : 'loadingProgressState',
    default : 0
});